import { routes } from '@pmai/contracts';
import { Button, EmptyState } from '@pmai/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TaskDialog } from '../../entities/tasks/task-dialog';
import { TaskSummaryLine, TasksTable } from '../../entities/tasks/tasks-table';
import { useApiQuery } from '../../shared/api/hooks';
import { Can } from '../../shared/auth/session';
import { CardSection } from '../../shared/card-section';

/** "Uzdevumi" on the project card (FR-TASK-001…009): summary, board order, add/edit/done/delete. */
export function ProjectTasksSection({ projectId }: { projectId: string }) {
  const { t } = useTranslation();
  const scope = { kind: 'project', id: projectId } as const;
  const tasks = useApiQuery(routes.tasks.list, { query: { projectId, order: 'board' } });
  const [adding, setAdding] = useState(false);

  return (
    <CardSection
      id="project.tasks"
      title={t('projects.sections.tasks')}
      actions={
        <Can perm="tasks.edit">
          <Button size="sm" icon="plus" onClick={() => setAdding(true)}>
            {t('tasks.add')}
          </Button>
        </Can>
      }
    >
      <div className="flex flex-col gap-3">
        {!!tasks.data?.rows.length && <TaskSummaryLine summary={tasks.data.summary} />}
        <TasksTable
          label={t('projects.sections.tasks')}
          rows={tasks.data?.rows}
          loading={tasks.isPending}
          columns={['check', 'title', 'assignee', 'plan', 'fact', 'deadline', 'actions']}
          scope={scope}
          empty={<EmptyState icon="list-checks" title={t('tasks.empty')} />}
        />
      </div>
      <TaskDialog open={adding} task={null} scope={scope} onClose={() => setAdding(false)} />
    </CardSection>
  );
}
